import React from 'react';
import PropTypes from 'prop-types';

export default function FileProgressBar({ progress }) {
  return (
    <div style={{ width: '100%', height: '4px', backgroundColor: '#BDBDBD' }}>
      <div style={{ width: `${progress}%`, height: '4px', backgroundColor: '#2B6ED3' }} />
    </div>
  );
}

FileProgressBar.propTypes = {
  progress: PropTypes.number.isRequired,
};
